const state = {
    loading: false,
    message: 'Loading...please wait',
    homeLoading: false,
};

const mutations = {
    // loading must be true/false
    TOGGLE_LOADING(state, payload) {
        state.loading = payload.set;
        state.message = payload.message;
    },
    TOGGLE_HOME_LOADING(state, payload) {
        state.homeLoading = payload.set;
    },
};

// getters
const getters = {
    isLoading: (state) => {
        return Boolean(state.loading);
    },
    isHomeLoading: (state) => {
        return Boolean(state.homeLoading);
    },
};

const actions = {
    toggleLoading({ commit }, payload) {
        commit('TOGGLE_LOADING', payload);
    },
    toggleHomeLoading({ commit }, payload) {
        commit('TOGGLE_HOME_LOADING', payload);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
